import { useAccount } from '@air/utils-auth';

import { useCanMountPrivateOnboardingIntro } from '~/components/v2/components/workspace/onboarding-intro/hooks/useCanMountPrivateOnboardingIntro';
import { useIsOnboardingIntroPending } from '~/components/v2/store/features/onboarding/useOnboardingPreferencesStore';

/**
 * Whether the overlay should be in the tree. `PrivateOnboardingIntroMount` uses this
 * so the intro chunk is not loaded for existing users or after this account has already watched it.
 */
export const useIsPrivateOnboardingIntroVisible = (): { isPrivateOnboardingIntroVisible: boolean } => {
  const { data: account } = useAccount();
  const { canMountPrivateOnboardingIntro } = useCanMountPrivateOnboardingIntro();
  const isIntroPending = useIsOnboardingIntroPending(account?.id);

  return {
    isPrivateOnboardingIntroVisible: canMountPrivateOnboardingIntro && isIntroPending,
  };
};
